import AxiosInstance from '../../config/AxiosInstance';

interface SigninPayload {
    email: string,
    password: string,
    deviceType: string,
    operatingSystem: string,
    browserInfo: string,
    userAgent: string
}

interface LogoutPayload {
    sessionId: string,
}

interface ResetPasswrodPayload {
    email: string,
}

interface ResetPasswrodConfirmPayload {
    token: string,
    newPassword: string,
}

const signin = async (payload: SigninPayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/auth/login', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const logout = async (payload: LogoutPayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/auth/logout', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const resetPaswordConfirm = async (payload: ResetPasswrodConfirmPayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/auth/reset-password-confirm', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};



const resetPasword = async (payload: ResetPasswrodPayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/auth/reset-password', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const changePassword = async (payload: any) => {
    try {
        const { userId, ...payloadWithoutUserId } = payload || {};
        const { data } = await AxiosInstance.put('/api/auth/change-password', payloadWithoutUserId);
        return { data };
    } catch (error) {
        throw error;
    }
};

const checkEmailAccountant = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/users/checkInviteCompanyAccountant', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};


const accepetJoinCompany = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/companies/acceptJoinCompany', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};



export {
    signin,
    logout,
    resetPasword,
    resetPaswordConfirm,
    checkEmailAccountant,
    accepetJoinCompany,
    changePassword
}